import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="stopped-site-note"
// サイト選択で WordPress連携が停止中のサイト（option の data-stopped="true"）を選んだときだけ注意書きを表示する
export default class extends Controller {
  static targets = ["select", "note"]

  declare readonly selectTarget: HTMLSelectElement
  declare readonly noteTarget: HTMLElement

  connect(): void {
    this.toggle()
  }

  toggle(): void {
    const selected = this.selectTarget.selectedOptions[0]
    const stopped = selected?.dataset.stopped === "true"
    this.noteTarget.classList.toggle("d-none", !stopped)
  }
}
